/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCalendarRange: {
  name: 'calendar-range';
  data: string;
} = {
  name: 'calendar-range',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 3a1 1 0 1 0-2 0v1H9V3a1 1 0 0 0-2 0v1H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V3ZM7 7V6H5v14h14V6h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0Zm1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
